import { render, staticRenderFns } from "./loanpaymentreport.vue?vue&type=template&id=0b3ea17d"
import script from "./loanpaymentreport.vue?vue&type=script&lang=js"
export * from "./loanpaymentreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports